// SignupPage.tsx
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { updateUserField } from "../../redux/slices/userSlice";

export default function SignupPage() {
  const { loginWithRedirect } = useAuth0();
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (code) {
        sessionStorage.setItem('referral_code', code);
        dispatch(updateUserField({ key: 'referralCode', value: code }));
      }
    } catch (e) {
      console.error("Error", e)
    }

    loginWithRedirect({
      authorizationParams: {
        screen_hint: "signup",
      },
    });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginWithRedirect]);

  return <p>Redirecting to signup…</p>;
}
